<!-- 预览附件: PDF、图片 支持多页预览和放大、缩小等 -->
<template>
  <div class="preview-attachment-plus">
    <div
      v-if="!listType"
      style="display: flex; align-items: flex-start; justify-content: flex-start"
    >
      <Button v-if="value?.length > 0" type="text" @click.stop="handleView">
        <span :style="{ fontSize, marginRight: '12px' }">{{ BUTTON_text }}</span>
      </Button>
      <upload-attachment
        v-if="reupload"
        ref="upload"
        :show-upload-list="false"
        :type="type"
        :uploadText="uploadText"
        :format="format"
        :max-size="maxSize"
        :catalogCode="catalogCode"
        :dataId="dataId"
        :dataCode="dataCode"
        :dataName="dataName"
        :valueIsObj="valueIsObj"
        @input="onInput"
      >
      </upload-attachment>
      <span v-if="!value?.length">-</span>
    </div>
    <!-- 列表模式 -->
    <thumb-list v-else :items="attachs" :pdfScale="pdfScale" :listType="listType"></thumb-list>

    <!-- 预览附件 -->
    <preview-img-and-pdf
      v-model="visible"
      :data="attachs"
      :pdfScale="pdfScale"
      :zoomMin="zoomMin"
      :zoomMax="zoomMax"
      :domTransfer="domTransfer"
      :transfer="transfer"
    />
  </div>
</template>

<script setup>
import { ref, watch, computed, getCurrentInstance } from 'vue'
import thumbList from './components/thumbList.vue'
import uploadAttachment from './components/uploadAttachment/uploadAttachment.vue'
import PreviewImgAndPdf from './components/previewImgAndPdf.vue'
import previewImgAndPdfProps from './props/previewImgAndPdfProps'

const instance = getCurrentInstance()
const that = instance.proxy

const props = defineProps({
  ...previewImgAndPdfProps,
  value: {
    type: Array,
    default() {
      return []
    },
  },
  size: {
    type: [Number, String],
    default: 14,
  },
  BUTTON_text: {
    type: String,
    default: '查看附件',
  },
  BUTTON_reupload_text: {
    type: String,
    default: '重传附件',
  },
  // 重传附件
  reupload: {
    type: Boolean,
    default: false,
  },
  reuploadUrl: {
    type: String,
    default: '',
  },
  reuploadMethod: {
    type: String,
    default: 'post',
  },
  reuploadParams: {
    type: Object,
    default() {
      return {}
    },
  },
  action: {
    type: String,
    default: 'rest/ezcomp/file/uploadFile',
  },
  type: {
    type: String,
    default: 'drag',
  },
  catalogCode: {
    type: String,
    default: '',
  },
  dataId: {
    type: String,
    default: '',
  },
  dataCode: {
    type: String,
    default: '',
  },
  dataName: {
    type: String,
    default: '',
  },
  uploadText: {
    type: String,
    default: '上传附件',
  },
  valueIsObj: {
    type: Boolean,
    default: false,
  },
  format: {
    type: Array,
    default: function () {
      return ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'docx', 'doc', 'xlsx', 'xls', 'pdf', 'rar', 'zip']
    },
  },
  maxSize: {
    type: Number,
    default: 10240,
  },
  ifForm: {
    type: Boolean,
    default: false,
  },
  formData: {
    type: Object,
    default() {
      return {}
    },
  },
})

const visible = ref(false)
const attachs = ref([]) // 附件

const fontSize = computed(() => {
  const size = `${props.size}`.replace(/%/g, '')
  if (/px$/i.test(`${size}`)) return size
  return `${size || 14}px`
})

// 打开预览
const handleView = () => {
  const url = props.value?.[0]?.url
  if (url) {
    visible.value = true
    attachs.value = props.value
  }
}

const onInput = (value) => {
  const newAttachs = props.value?.length > 0 ? [...props.value, ...value] : value
  const param = props.ifForm ? props.formData : { ...props.reuploadParams, attach: newAttachs }
  if (props.reupload && props.reuploadUrl) {
    that.$axios[props.reuploadMethod ?? 'post'](props.reuploadUrl, { ...param }, (res) => {
      console.log(res)
      that.$Message.success('附件重传成功')
    })
  }
}

watch(
  () => visible.value,
  (_visible) => {
    console.log('_visible: ', _visible)
    if (!_visible) attachs.value = [] // #37104, 优化可能出现加载不出 PDF 的问题
  }
)

watch(
  () => props.value,
  (value) => {
    if (!props.listType) return // 非列表模式不处理

    if (value?.length > 0) {
      attachs.value = value
    } else {
      attachs.value = []
    }
  },
  { immediate: true }
)
</script>
